{
  "close": "Sluiten",
  "notifications": "{count, plural, one {# melding} other {# meldingen}}."
}
